export let RequestState;
(function (RequestState) {
  RequestState[RequestState["UNINITIALIZED"] = 0] = "UNINITIALIZED";
  RequestState[RequestState["PENDING"] = 1] = "PENDING";
  RequestState[RequestState["SUCCEEDED"] = 2] = "SUCCEEDED";
  RequestState[RequestState["FAILED"] = 3] = "FAILED";
  RequestState[RequestState["CANCELED"] = 4] = "CANCELED";
})(RequestState || (RequestState = {}));